(function () {
  'use strict';

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function addVariant(variantId, quantity) {
    var response = await fetch(getRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: Number(quantity || 1)
        }]
      })
    });

    if (!response.ok) {
      var message = 'Unable to add this item.';
      try {
        var error = await response.json();
        message = error.description || error.message || message;
      } catch (e) {}
      throw new Error(message);
    }

    return response.json();
  }

  function initSection(section) {
    if (!section || section.dataset.rouxResultsReady === 'true') return;
    section.dataset.rouxResultsReady = 'true';

    section.addEventListener('click', async function (event) {
      var button = event.target.closest('[data-roux-card-add]');
      if (!button || !section.contains(button) || button.disabled) return;

      event.preventDefault();

      var variantId = Number(button.dataset.variantId || 0);
      if (!variantId) return;

      var label = button.querySelector('[data-add-label]');
      var status = button.closest('.roux-results-feed__product')?.querySelector('[data-card-status]');
      var defaultLabel = button.dataset.defaultLabel || 'ADD TO CART';

      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = 'ADDING...';
      if (status) status.textContent = '';

      try {
        var added = await addVariant(variantId, 1);

        if (label) label.textContent = 'ADDED';
        if (status) status.textContent = 'ROUX added to cart.';

        document.dispatchEvent(new CustomEvent('roux:cart:refresh', {
          detail: {
            open: true,
            source: 'roux-results-feed',
            added: added
          }
        }));

        document.dispatchEvent(new CustomEvent('product:added', {
          detail: {
            source: 'roux-results-feed',
            added: added
          }
        }));

        window.setTimeout(function () {
          if (!button.isConnected) return;
          button.disabled = false;
          button.classList.remove('is-loading');
          if (label) label.textContent = defaultLabel;
        }, 850);
      } catch (error) {
        if (label) label.textContent = 'TRY AGAIN';
        if (status) status.textContent = error.message || 'Unable to add this item.';

        window.setTimeout(function () {
          if (!button.isConnected) return;
          button.disabled = false;
          button.classList.remove('is-loading');
          if (label) label.textContent = defaultLabel;
        }, 1400);
      }
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-roux-results-feed]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();